<template>
  <div class="finesgoods-Add">
    <el-form ref="form" :model="form" :rules="rules" label-width="125px">
      <el-form-item label="名称：" prop="boutiqueName">
        <el-input v-model="form.boutiqueName"></el-input>
      </el-form-item>
      <el-form-item label="英文名：" prop="boutiqueEnglishName">
        <el-input v-model="form.boutiqueEnglishName"></el-input>
      </el-form-item>
      <el-form-item label="详细介绍：" prop="boutiqueDetail">
        <el-input type="textarea" v-model="form.boutiqueDetail"></el-input>
      </el-form-item>
      <el-form-item label="排序：" prop="boutiqueSort">
        <el-input v-model="form.boutiqueSort"></el-input>
      </el-form-item>
      <el-form-item label="配件类别：" prop="boutiqueCategory">
        <el-select v-model="form.boutiqueCategory" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图片：" class="uploadImg" prop="boutiqueUrl">
        <upload
          :url="form.boutiqueUrl"
          @successUpload="handleSuccessUpload"
          prompt="上传封面图片：大小不超过2M，支持Jpeg、Jpg、Png格式，建议上传690*300尺寸。"
        />
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" :loading="loading" @click="onSubmit('form')">保存</el-button>
        <el-button @click="$router.push({name:'FinesGoodList'})">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addBoutique } from '@/api/goods';
import Upload from '@/components/Upload/index.vue';
import { validCurrency } from '@/utils/validate';

export default {
  data() {
    const validNumber = (rule, value, callback) => {
      if (validCurrency(value)) {
        callback();
      } else {
        callback(new Error('请输入正确数字值!'));
      }
    };
    return {
      loading: false,
      form: {
        boutiqueName: '',
        boutiqueEnglishName: '',
        boutiqueDetail: '',
        boutiqueSort: '',
        boutiqueCategory: '',
        boutiqueUrl: '',
      },
      options: [{
        value: '保湿箱',
        label: '保湿箱',
      }, {
        value: '烟灰缸',
        label: '烟灰缸',
      }, {
        value: '剪刀',
        label: '剪刀',
      }, {
        value: '火机',
        label: '火机',
      }, {
        value: '其他配件',
        label: '其他配件',
      }],
      rules: {
        boutiqueName: [
          { required: true, message: '请输入中文名称', trigger: 'blur' },
        ],
        boutiqueEnglishName: [
          { required: true, message: '请输入英文名称', trigger: 'blur' },
        ],
        boutiqueDetail: [
          { required: true, message: '详细介绍不能为空', trigger: 'blur' },
        ],
        boutiqueSort: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
          { validator: validNumber, trigger: 'blur' },
        ],
        boutiqueCategory: [
          { required: true, message: '请选择配件类别', trigger: 'change' },
        ],
      },
    };
  },
  components: {
    Upload,
  },
  methods: {
    addBoutique() {
      this.loading = true;
      addBoutique(this.form).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$router.push({ name: 'FinesGoodList' });
          this.$message.success('配件添加成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.form.boutiqueUrl) {
            this.$message.warning('请上传商品图片');
            return false;
          }
          this.addBoutique();
          return true;
        }
        return false;
      });
    },
    handleSuccessUpload(url) {
      this.form.boutiqueUrl = url;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.finesgoods-Add
  .el-form
    width 700px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      text-align center
</style>
